export default __webpack_public_path__ + "file-asset/f34f9676d4e4ce06a0d064408de02709-dormakaba_sample.csv";